import React from 'react'
import useRenderClassComponent from '../../hooks/useRenderClassComponent';
import GenericTableData from '../../components/dashboard/salesOrder/GenericTableData';
import { CONFIG } from '../../config';
import { getPermissionKey } from '../../helper/permissions';

function VendorDetailsOpenPO(props) {
    const { generalStore, digivendStore, tableHeadersMap = {} } = props || {};

    console.log('digivendStore?.getAllOrdersData?.data?.resource', digivendStore?.getAllOrdersData?.data?.resource)

    return (
        <div className='vendorDetailsOpenPo'>
            <div className="sd-sec">
                <React.Fragment>
                    {
                        useRenderClassComponent(GenericTableData, {
                            actionBarConfig: {
                                quickFilter: {
                                    disabled: generalStore?.getQuickFiltersData?.isLoading
                                },
                                filters: {
                                    disabled: generalStore?.getHeadersData?.isLoading,
                                },
                                search: true,
                                // downloadReport: {
                                //     headerLevelModule: tableHeadersMap?.main?.key,
                                //     tableHeadersMap: tableHeadersMap,
                                //     api: {
                                //         payload: (payload) => {
                                //             console.log("check payload", payload);
                                //             payload.data.excelData = true;
                                //             return {
                                //                 ...payload,
                                //                 apiUrl: "/admin/download/module/data/export",
                                //                 baseUrl: CONFIG.SM_BACKEND_BASE_URL,
                                //             }
                                //         }
                                //     }
                                // },
                            },
                            tableConfig: {
                                pagination: true
                                // toggleitem: {
                                //     render: toggleItemsButtons,
                                // },
                            },
                            tableHeadersPayload: tableHeadersMap,
                            quickFiltersPayload: {
                                attributeType: "ENT_PENDING_ALL",
                                displayName: "ENT_PENDING_ALL",
                                filterName: ""
                            },
                            tableComExtraHeaders: getPermissionKey("dashboard", "ordertracking", "view"),
                            tableDataPayload: {
                                "displayName": "ENT_PENDING_ALL",
                                "pageNo": 1,
                                "pageSize": 10,
                                "sortedBy": "",
                                "sortedIn": "",
                                "search": "",
                                "filter": {vendorCode: props?.vendorDetailsConfig?.vendorCode || ""},
                            },
                            getTableDataRequest: 'getAllOrdersRequest',
                            getTableDataLoading: digivendStore?.getAllOrdersData?.isLoading,
                            getTableDataSuccess: digivendStore?.getAllOrdersData?.isSuccess,
                            getTableDataError: digivendStore?.getAllOrdersData?.isError,

                            tableData: {
                                data: digivendStore?.getAllOrdersData?.data?.resource || [],
                                totalItems: digivendStore?.getAllOrdersData?.data?.totalRecord || 0,
                                currentPage: digivendStore?.getAllOrdersData?.data?.currPage || 1,
                                maxPage: digivendStore?.getAllOrdersData?.data?.maxPage || 1
                            },

                            generalStore: generalStore,
                            digivendStore: digivendStore,
                            // refreshData: digivendStore?.getAllOrdersData?.isSuccess
                        },
                            ["generalStore", "digivendStore"],
                        )}
                </React.Fragment>
            </div>
        </div>
    )
}

export default VendorDetailsOpenPO
